import {
  Slot
} from "@radix-ui/react-slot"
import {
  cva, type VariantProps
} from "class-variance-authority"
import * as React from "react"

import {
  cn
} from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap  font-medium transition-colors focus-visible_outline-none focus-visible_ring-1 focus-visible_ring-ring disabled_pointer-events-none disabled_opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-theme w-full h-[48px] text-white font-Shango hover_bg-white hover_border hover_border-solid hover_border-theme hover_text-theme flex justify-center items-center",
        secondary:
          " w-40 h-10  text-center border-theme border border-solid text-theme font-Shango bg-bglighttheme",
        third: "border-2 border-solid cursor-pointer font-bold inline-flex items-center justify-center leading-tight max-w-full outline-none pointer-events-auto px-sm text-center text-sm uppercase bg-secondary border-secondary text-white hover_bg-primary hover_border-primary hover_text-white transition-all border-none bg-white hover_bg-secondary text-[#111] hover_text-white",
        outline: "bg-white border-primary border-1 border-solid w-full h-[48px] text-primary font-Shango hover_bg-primary hover_text-white flex justify-center items-center"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  className, variant, size, asChild = false, ...props 
}, ref) => {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      className={cn(buttonVariants({
        variant, size, className 
      }))}
      ref={ref}
      {...props}
    />
  )
})

Button.displayName = "Button"

export {
  Button, buttonVariants
}

